import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {ExamReportStatus} from "../../generated-client/generated-api-client";

@Injectable()
export class ExamReportDataService {
  examReportStatus = new BehaviorSubject<ExamReportStatus | undefined>(undefined);
  isModifiable = new BehaviorSubject<boolean | undefined>(undefined);
}
